<template>
  <div>
    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <associated-entities-loan-stage-provider
        ref="associatedEntitiesLoanStageProvider"
        associated-entity-heading="Co-applicants and Guarantors"
        toolbar-title="Co-applicants and Guarantors"
        :current-task-name="currentTaskName"
        :associated-entity-types="associatedEntityTypes"
    ></associated-entities-loan-stage-provider>

  </div>
</template>

<script>

import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import {Activities} from "@/utils/ActivityNavigator";
import AssociatedEntitiesLoanStageProvider
  from "@/components/providers/AssociatedEntitiesLoanStageProvider";
import { AssociatedEntityType } from "@/components/Constants";

export default {
  name: "CoApplicantOrGuarantorActivity",
  components: { ActivityRedirectItem, AssociatedEntitiesLoanStageProvider },

  mounted() {
    this.$refs.associatedEntitiesLoanStageProvider.fetchInitialDataExternal();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.ASSOCIATED_ENTITY];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    associatedEntityTypes() {
      return [AssociatedEntityType.CO_APPLICANT.rawValue, AssociatedEntityType.GUARANTOR.rawValue];
    }
  }
}
</script>

<style scoped></style>
